module.exports = __webpack_public_path__ + "static/TUEV-b06b5469f7037fdd5cbdbbc0c62eec4c.svg";